import React, { useState, useEffect, useContext, Fragment } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl';

import NodeRSA from 'node-rsa'
import { Modal, Button, Spin, Statistic } from 'antd'
import Image from 'next/image'
import QrCode from 'qrcode.react'

import { CommonError } from '@/components/H5PC/CommonMethod.js'


import { paymentJaPayflow, getInitCardInfo } from '@/components/H5PC/service';
import myContext from '@/utils/createContext'
import LinkPay from './LinkPay'
import { localStorage, reportEventToMonitor } from '@/utils'


const { Countdown } = Statistic


const Evonet = (props) => {
    const lang = localStorage.getItem('locale')

    const { payMethods, urlParams, payData, infoData, intl } = props;
    const { isMobileView, loading, actualPaymentAmount, setLoading, actualPaymentCurrency, publicKey, key, token, type, checkPolling, orderStatus } = useContext(myContext) || {}

    const { formatMessage } = intl
    const [qrTtl, setQrTtl] = useState(0)
    const [qrCode, setQrCode] = useState('')
    const [action, setAction] = useState('');
    const [codeValid, setCodeValid] = useState(false)
    const [evonetLoading, setEvonetLoading] = useState(true)
    const [redirectUrl, setRedirectUrl] = useState('');


    useEffect(() => {
        console.log(orderStatus);
        if (type && publicKey && (orderStatus && orderStatus != 'PS')) {
            console.log('当前支付方式为：', type)
            fetchData(token, publicKey)
        }
    }, [type, publicKey, orderStatus])

    const fetchData = async (token, publicKey) => {

        let params = {}

        params = {
            terminalType: isMobileView ? 'WAP' : 'WEB',
            paymentType: type,
        }

        const pubKey = new NodeRSA(publicKey, 'pkcs8-public')

        // 必须得加，要和java加密解密统一
        pubKey.setOptions({ encryptionScheme: 'pkcs1' })
        const newParams = JSON.stringify(params)
        const encrypt_data = pubKey?.encrypt(newParams, 'base64')
        // 加密后的参数
        payment(token, encrypt_data)
    }

    const payment = async (token, encrypt_data) => {
        setEvonetLoading(true)
        const params = {
            encrypted: encrypt_data,
            token,
        }
        const res = await paymentJaPayflow('offline', key, params);
        if (res.code === 600001 || res.code === 600002) {
            const resNext = await getInitCardInfo('cashier', key);
            const myToken = resNext && resNext.data && resNext.data.token;
            const myPublicKey = resNext && resNext.data && resNext.data.publicKey

            fetchData(myToken, myPublicKey)
        }

        if (res && res.code === 200000) {
            if (res.data.paymentStatus === 'PF') {
                Modal.warning({
                    width: isMobileView ? '80%' : '500px',
                    centered: true,
                    // content: CodeMsg(res.code),
                    content: formatMessage({ id: 'ga-checkout.error-990000' }),
                    className: isMobileView ? 'h5pc-cashier-error_modal' : '',
                    // okText: 'Got It',
                    okText: formatMessage({ id: 'ga-checkout.got-it' }),
                    onOk() {
                        return new Promise((resolve, reject) => {
                            setLoading(false);
                            setTimeout(Math.random() > 0.5 ? resolve : reject, 500);
                        }).catch(() => console.log('error!'));
                    },
                });
            } else {
                setEvonetLoading(false)
                setAction(res.data?.action)
                if (res.data.qrCode) {
                    setCodeValid(true)

                    //  显示即轮询,且只调该轮询一次
                    if (!qrCode) {
                        checkPolling()
                    }
                    // 获取二维码
                    setQrCode(res.data?.qrCode)

                    setQrTtl(res.data?.effectiveTime)
                }
                if (res.data.redirectUrl) {
                    setRedirectUrl(res.data.redirectUrl)
                } else {
                    reportEventToMonitor(`${type} PC端接口出参报警(cashier_parameter_output): redirectUrl不存在; 支付结果接口url=/payment/offline/payflow/${key};`)
                }
            }
        } else if (res.code === 200100) {
            Modal.warning({
                width: isMobileView ? '80%' : '500px',
                centered: true,
                className: isMobileView ? 'h5pc-cashier-error_modal' : '',
                // content: CodeMsg(990000),
                content: formatMessage({ id: 'ga-checkout.error-200100' }),
                // okText: 'Got It',
                okText: formatMessage({ id: 'ga-checkout.got-it' }),
                onOk() {
                    return new Promise((resolve, reject) => {
                        setLoading(false);
                        window.location.href = '/success?errorCode=200100'
                    }).catch(() => console.log('error!'));
                },
            });
        } else {
            CommonError(props, isMobileView, setLoading, res);
        }
    }

    const onCountdownFinish = () => {
        setCodeValid(false)
        setQrTtl(0)
    }


    // 重新获取二维码
    const refreshCode = () => {
        // const methods = payMethods.filter(x => x.indexOf('_TM') > -1)
        const params = {
            terminalType: 'WEB',
            paymentType: type,
        }
        const pubKey = new NodeRSA(publicKey, 'pkcs8-public')

        // 必须得加，要和java加密解密统一
        pubKey.setOptions({ encryptionScheme: 'pkcs1' })
        const newParams = JSON.stringify(params)
        const encrypt_data = pubKey?.encrypt(newParams, 'base64')

        payment(token, encrypt_data)
    }

    const renderText = () => {
        const _html = <>
            <span style={{ marginRight: 5, verticalAlign: 'super' }}>
                <FormattedMessage id={`evonet.${type}.qr.tip`} />
            </span>
        </>
        return _html
    }

    const deadline = Date.now() + qrTtl * 1000

    return (
        <myContext.Provider value={{
            payMethods,
            urlParams,
            isMobile: isMobileView,
            checkPolling,
            payData,
            infoData,
            setLoading,
            intl,
            loading,
            actualPaymentAmount,
            actualPaymentCurrency,
            publicKey,
            key,
            token,
            type,
            redirectUrl
        }}>
            {
                evonetLoading && !action ? (
                    <Spin size="medium" style={{ margin: '0 auto', width: '100%' }}></Spin>
                )
                    :
                    // 码支付
                    action === 'QRCODE' ?
                        <Fragment>
                            <div className="qr">
                                <div className="qr-code">
                                    <div className="qr-code-title" style={{ textAlign: 'center' }}>
                                        {renderText()}
                                    </div>
                                    {loading ? (
                                        <Spin size="medium"></Spin>
                                    ) : (
                                        <Fragment>
                                            <div className="qr-code-img">
                                                {codeValid ? (
                                                    <div className="qr-code-img-valid">
                                                        <QrCode value={qrCode} size={200} id="truemoney code" />
                                                        <div className="qr-code-countdown">
                                                            {
                                                                lang === 'zh-CN' || lang === 'zh-TW' || lang === 'ja-JP' ?
                                                                    <>
                                                                        <FormattedMessage id="thai-qr.countdown-before" />
                                                                        <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                                        <FormattedMessage id="thai-qr.countdown-mins" />
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <FormattedMessage id="thai-qr.countdown" />
                                                                        <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                                        <FormattedMessage id="thai-qr.countdown-mins" />
                                                                    </>
                                                            }
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="qr-code-img-invalid" onClick={refreshCode}>
                                                        <Image src="/static/images/shixiao@3x.png" alt="invalid" width={230} height={250} />
                                                        <div className="qr-code-img-invalid-refresh">
                                                            <Image src="/static/images/shuaxin@2x.png" alt="invalid" width={18} height={18} />
                                                            <br />
                                                            <Button type="link">
                                                                <FormattedMessage id="thai-qr.refresh" />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        </Fragment>
                        :
                        action === 'DOWNLOAD_ORCODE' && qrCode ?
                            <Fragment>
                                <div className="qr">
                                    <div className="qr-code">
                                        {loading ? (
                                            <Spin size="medium"></Spin>
                                        ) : (
                                            <Fragment>
                                                <div className="qr-code-img">
                                                    {codeValid ? (
                                                        <div className="qr-code-img-valid">
                                                            <div style={{ textAlign: 'center' }}>
                                                                <Image src={qrCode} width={230} height={300} />
                                                            </div>
                                                            <div className="qr-code-countdown">
                                                                {
                                                                    lang === 'zh-CN' || lang === 'zh-TW' || lang === 'ja-JP' ?
                                                                        <>
                                                                            <FormattedMessage id="thai-qr.countdown-before" />
                                                                            <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                                            <FormattedMessage id="thai-qr.countdown-mins" />
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <FormattedMessage id="thai-qr.countdown" />
                                                                            <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                                            <FormattedMessage id="thai-qr.countdown-mins" />
                                                                        </>
                                                                }
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="qr-code-img-invalid" onClick={refreshCode}>
                                                            <Image src="/static/images/shixiao@3x.png" alt="invalid" width={230} height={250} />
                                                            <div className="qr-code-img-invalid-refresh">
                                                                <Image src="/static/images/shuaxin@2x.png" alt="invalid" width={18} height={18} />
                                                                <br />
                                                                <Button type="link">
                                                                    <FormattedMessage id="thai-qr.refresh" />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>
                                </div>
                            </Fragment>
                            :
                            // 链接支付
                            action === 'REDIRECT' ?
                                <LinkPay />
                                :
                                ''
            }
        </myContext.Provider>
    )
}

export default injectIntl(Evonet)